import Vue from "vue";
import { COGNITO_API_WEB_ROOT, sso, regions, provider, providers, settings, statusKey, list, metaInfo, pool, meta, user, uploadidpmeta } from "./urls";

const providerNameResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${providers}`);

const providerRegionResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${regions}`);

const entityIDAndAcsURLResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${pool}/${metaInfo}`);

const updateProviderDetailsResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${provider}{/id}/${settings}/${meta}`, {}, { update: { method: "PATCH" } });

const addProviderDetailsResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${providers}`);

const toggleStatusResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${provider}{/id}/${settings}/${statusKey}`, {}, { update: { method: "PATCH" } });

const deleteListResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${provider}{/id}`);

const providersListResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${providers}/${list}`);

const loginInfoResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${provider}/${metaInfo}`);

const ssoEnabledForUserResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${user}`, {});

const s3UploadUrlResource = Vue.resource(`${COGNITO_API_WEB_ROOT}${sso}/${uploadidpmeta}`);

export function getProviderNameDetails() {
  return providerNameResource.get();
}

export function getProviderRegionDetails() {
  return providerRegionResource.get();
}

export function getProviderListDetails() {
  return providersListResource.get();
}

export function getToggleStatus(pathParams, data) {
  return toggleStatusResource.update(pathParams, data);
}

export function getSSOLoginInfo() {
  return loginInfoResource.get();
}

export function updateEntityIDAndAcsURLDetails(region) {
  //API to Provide ACS URL and Entity Id of Cognito Pool of specific region
  return entityIDAndAcsURLResource.save({ region }); //POST
}

export function updateProviderDetails(payload) {
  return updateProviderDetailsResource.update({ id: payload.id }, payload); //API to Modify Meta File/URL
}

export function addProviderDetails(payload) {
  return addProviderDetailsResource.save(payload); //add provider Details -- EntityID and ACS URL
}

export function deleteProviderList(pathParams) {
  return deleteListResource.delete(pathParams);
}

export function checkIfSSOEnabledForUser(data) {
  return ssoEnabledForUserResource.save(data);
}

export function getS3UploadUrlResource() {
  return s3UploadUrlResource.get();
}
